// The secret type templates (secrets/templates.ts): names, value labels and hints.
import type { FieldName } from "../../../../secrets/fields";
import type { Facet, TemplateId } from "../../../../secrets/templates";

export default {
  label: {
    github: "GitHub token",
    anthropic_api_key: "Anthropic API key",
    claude_subscription: "Claude subscription token",
    jira: "Jira",
    asana: "Asana",
    cursor_api_key: "Cursor API key",
    slack: "Slack",
    database: "Database",
    http_api_key: "HTTP API key",
    vpn_profile: "VPN profile (.ovpn)",
    other: "Other",
  } satisfies Record<TemplateId, string>,
  value: {
    github: "Token",
    anthropic_api_key: "API key",
    claude_subscription: "Token from `claude setup-token`",
    jira: "API token",
    asana: "Personal access token",
    cursor_api_key: "API key",
    slack: "Bot token",
    http_api_key: "API key",
    vpn_profile: "Profile (.ovpn)",
    other: "Value",
  } satisfies Record<Exclude<TemplateId, "database">, string>,
  hint: {
    github: "Fine-grained PAT; the broker calls GitHub",
    anthropic_api_key: "Model calls billed per token",
    claude_subscription: "From claude setup-token",
    jira: "Site URL, email and API token, limited to projects",
    asana: "Personal access token for an Asana source",
    cursor_api_key: "Coming soon: Cursor runs are refused for now",
    slack: "Bot token for posting",
    database: "Host, port, user, password",
    http_api_key: "Injected as a header for allowed hosts",
    vpn_profile: "AWS Client VPN profile for your environment",
    other: "A name and a value",
  } satisfies Record<TemplateId, string>,
  scope: {
    repos: "Repositories",
    projects: "Projects",
    channels: "Channels",
    databases: "Databases",
  } satisfies Record<Facet, string>,
  field: {
    host: "Host",
    port: "Port",
    user: "User",
    password: "Password",
    database: "Database",
    site: "Jira site URL",
    email: "Email",
    api_token: "API token",
  } satisfies Record<FieldName, string>,
  newValue: "New value",
  valueEmpty: "The value is empty",
  fieldEmpty: (label: string) => `${label} is empty`,
  siteInvalid: "The Jira site URL must be a web address such as https://acme.atlassian.net",
  jiraHelp:
    "The site is the address you open Jira at. Use the email you sign in to Jira with and an API token from id.atlassian.com → Security → API tokens. All three are sealed together.",
  vpnHelp:
    "Paste the profile or load the .ovpn file you downloaded from your VPN self-service page. It is sealed for the server; only your environment's VPN client opens it.",
  fileTooLarge: (kb: number) => `The profile is larger than ${kb} KB`,
  loadFile: "Load a file",
};
